const translateActionChat = {
	// allowChatAssign: "Asignar Chat",
	allowEndChatWithoutMessage: "Finalizar sin Msj",
	allowEndChat: "Finalizar Chat",
	allowFreeChat: "Liberar Chat",
	allowTakeChat: "Tomar Chat",
	allowStartChat: "Iniciar Chat",
	allowTransferChat: "Transferir Chat",
	allowRemoveChat: "Quitar Chat",
	allowViewAllChats: "Ver todos los chats",
	allowSendFlow: "Enviar Flow",
	allowConfigFlow: "Configurar Flow",
};

export default translateActionChat;

export const orderedPermissions = [
	"allowEndChat",
	"allowFreeChat",
	"allowStartChat",
	"allowTakeChat",
	"allowTransferChat",
	"allowViewAllChats",
	"allowRemoveChat",
	"allowEndChatWithoutMessage",
	"allowSendFlow",
	"allowConfigFlow",
];
